import api from './api';
import axios, { AxiosError } from 'axios';

export interface MarketingCampaign {
  id: number;
  distributor_id: number;
  name: string;
  start_time: string;
  end_time: string;
  communication_type: 'banner' | 'modal';
  content_type?: 'text' | 'image' | 'video';
  message?: string;
  image_url?: string;
  video_url?: string;
  is_active: boolean;
  created_by: number;
  created_at: string;
  updated_at: string;
  distributor_name?: string;
  creator_name?: string;
}

export interface ActiveCampaignResponse {
  success: boolean;
  status_code: number;
  message: string;
  data: {
    campaign: MarketingCampaign | null;
  };
}

export interface ApiError {
  success: false;
  status_code: number;
  message: string;
  error?: string;
}

export const marketingApi = {
  /**
   * Get the active marketing campaign for the current contractor.
   * Returns null if no active campaign is found.
   */
  getActiveCampaign: async (): Promise<MarketingCampaign | null> => {
    try {
      const response = await api.get<ActiveCampaignResponse>('/marketing/campaigns/active');
      return response.data.data.campaign;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ApiError>;
        if (axiosError.response?.status === 401 || axiosError.response?.status === 403) {
          // Unauthorized or forbidden - no campaign available.
          return null;
        }
      } else {
        console.error('[marketingApi] Non-Axios error:', error);
      }
      return null;
    }
  },
};
